
    <ng-container *ngIf="routing$ | async as routing; else content">
      <a
        [attr.target]="routing.target"
        [routerLink]="routing.paths"
        [queryParams]="routing.queries"
        [matTooltip]="tooltip$ | async"
      >
        <fieldmagic-text
          [content]="content$ | async"
        >
        </fieldmagic-text>
      </a>
    </ng-container>

    <ng-template #content>
      <fieldmagic-text
        [content]="content$ | async"
        [purpose]="purpose$ | async"
        [matTooltip]="tooltip$ | async"
        (click)="onClicked()"
      >
      </fieldmagic-text>
    </ng-template>
  